/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { LeadUpdateRequestDtoV2, LeadUpdatedDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class LeadControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags lead-controller-v-2
   * @name Update5
   * @request PATCH:/api/v2/lead/{leadId}/funnel-step/{currentFunnelStep}
   */
  update = (
    leadId: string,
    currentFunnelStep:
      | 'emailPrequalified'
      | 'email'
      | 'numberOfEmployees'
      | 'registrationCountry'
      | 'legalForm'
      | 'productInterests'
      | 'cardSpend'
      | 'cardSpendSmallSpender'
      | 'cardsNeed'
      | 'isCreditRequired'
      | 'creditNeed'
      | 'numberOfInvoices'
      | 'invoicesNeed'
      | 'funnelIntent'
      | 'engagementStage'
      | 'erpSystem'
      | 'waitlist'
      | 'notForYou'
      | 'demoBookingP0'
      | 'demoBookingP1'
      | 'demoBookingP2'
      | 'selfSignup'
      | 'demoFromScratchP0',
    data: LeadUpdateRequestDtoV2,
    params: RequestParams = {},
  ) =>
    this.http.request<LeadUpdatedDto, any>({
      path: `/v2/lead/${leadId}/funnel-step/${currentFunnelStep}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v2/lead/${leadId}/funnel-step/${currentFunnelStep}'
  static updateMethod = 'PATCH'
}
